import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { DataService } from '../../e-met/services/data.service';
import { LocalStorageService } from '../../core/services/local-storage.service';
import { SharedService } from '../../e-met/services/shared.service';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
interface AccordionData {
    [key: string]: any;
    priceObject: {
        cadID: number;
        [key: string]: any;
    };
}
@Component({
    selector: 'app-accordion-submitable',
    templateUrl: './accordion-submitable.component.html',
    styleUrls: ['./accordion-submitable.component.scss'],
})
export class AccordionSubmitbleComponent implements OnInit, OnChanges {
    @Input() accordionData: any;
    constructor(
        private dataService: DataService,
        private localStorageService: LocalStorageService,
        private sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private cdr: ChangeDetectorRef
    ) {}

    appId = this.activatedRoute.snapshot?.params.id;
    applicationFormArray = new FormArray([]);
    ngOnInit(): void {
        this.sharedService.recalculateCharges$.subscribe((status) => {
            if (status.cadID) {
                this.getChargesFromFormValues(status);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // const key = 'accordionData';
        // console.log(changes , this.accordionData)
        // console.log(changes[key].currentValue != undefined , changes[key].currentValue , changes[key].currentValue?.length)
        // if(changes[key].currentValue){
        //   console.log('Will init form')
        //   this.handleFormArrayGeneration(this.accordionData)
        // }
        // if (changes['accordionData'].currentValue) {
        //     console.log('accordion data',changes['accordionData'].currentValue);
        //     this.handleFormArrayGeneration(this.accordionData);
        // }
    }

    handleFormArrayGeneration(data: AccordionData[]): void {
        this.applicationFormArray.clear();
        data.forEach((item) => {
            console.log('form generation ', item);
            let fg = new FormGroup({
                cadOfficeId: new FormControl(item.priceObject.cadID),
                buyerTaxId: new FormControl(null, Validators.required),
                paymentMethod: new FormControl(null, Validators.required),
            });
            if (item.priceObject.formGroup) {
                console.log('will override fg');
                fg = item.priceObject.formGroup;
            }
            this.applicationFormArray.push(fg);
        });
        this.applicationFormArray.valueChanges.subscribe({
            next: () => {
                this.sharedService.updateCanSubmitValue(
                    this.applicationFormArray.valid
                );
                this.sharedService.submissionDataSubject.next(
                    this.applicationFormArray.value
                );
            },
        });
        this.cdr.detectChanges();
    }
    getChargesFromFormValues(status) {
        this.dataService
            .getContractCharges(
                this.appId,
                status.commercialAmount,
                status.numOfReqCertificates,
                status.objectiveAmount
            )
            .subscribe(
                (data) => {
                    data = data.filter((item) => {
                        return item.cadOfficeId.toString() == status.cadID;
                    });
                    data = data[0];

                    this.accordionData.forEach((propElement, index) => {
                        if (propElement.priceObject.cadID == data.cadOfficeId) {
                            this.accordionData[index].priceObject.total =
                                data.chargeTotal;
                            this.accordionData[index].priceObject.items =
                                this.getcharges(data);
                        }
                    });
                    this.cdr.detectChanges();
                },
                (error) => {
                    console.log('ERROR', error);
                }
            );
    }
    getcharges(data) {
        let lineItems = [];
        if (data.charges) {
            for (const [key, value] of Object.entries(data.charges)) {
                lineItems.push({ name: key, price: value });
            }
        }

        return lineItems;
    }
}
